export default __webpack_public_path__ + "static/media/snd_00010.01220b06.mp4";